export default __webpack_public_path__ + "static/media/PressureTransducer.0434550a.jpg";